//
import SubFamilyModel from '@/models/Warehouse/WhSubfamily'

/**
 *
 */
const fetchByFamily = async ( wh_family_id ) => {
    //
    try {
        //
        const response = await SubFamilyModel.where( 'wh_family_id', wh_family_id ).get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}

//
export default fetchByFamily
